import PropTypes from 'prop-types';

export default function SegmentedControl({ options, value, onChange }) {
	const styleProperties = {
		'--items': options.length,
		'--index': options.findIndex((option) => option.value === value),
	};

	return (
		<div className="prc-segmented-control" style={styleProperties}>
			{options.map((option, index) => {
				return (
					<span
						key={index}
						className={value === option.value ? 'selected' : ''}
						onClick={() => onChange(option.value)}
						data-testid={`prc-segctrl-option-${option.value}`}
					>
						{option.label}
					</span>
				);
			})}
		</div>
	);
}

SegmentedControl.propTypes = {
	onChange: PropTypes.func.isRequired,
	options: PropTypes.array.isRequired,
	value: PropTypes.string,
};
